export enum Type {
    NEWS = 'NEWS',
    APPOINTMENT = 'APPOINTMENT'
}
